export default __webpack_public_path__ + "static/media/loader.d13ffea4.gif";